// Social proof - Maria's success story
import FeedbackPage from '@/components/FeedbackPage'

export default function MariaTestimonialPage() {
  return (
    <FeedbackPage emoji="💬" title="pages.onboarding.mariaTestimonial.title" />
  )
}
